import { ReactNode, createContext, useContext } from 'react';
import { UzumMode } from './uzumTokens';

const ThemeModeContext = createContext<UzumMode>('light');

/**
 * Light or dark, as the theme being rendered says — set by the theme's own
 * Provider (`../modules/theme/`), so it is the theme the app actually picked,
 * an "auto" choice resolved included.
 */
export function ThemeModeProvider(props: {
  mode: UzumMode;
  children: ReactNode;
}) {
  return (
    <ThemeModeContext.Provider value={props.mode}>
      {props.children}
    </ThemeModeContext.Provider>
  );
}

/**
 * The current mode, for what draws in its own palette and has to be told which
 * one: Mermaid, Scalar. BUI components need no such hint — they read the
 * `--bui-*` variables.
 */
export const useThemeMode = () => useContext(ThemeModeContext);
